import React, { useState } from "react"
import { Checkbox } from "flowbite-react";
import { differenceInDays, } from "date-fns";
import { BiMinusCircle, BiPlusCircle } from "react-icons/bi";
import { useContrato } from "../../../../../../../context/ContratoContext";
import { Contrato } from "../../../../../../../types/contratos-data-interface";
import { useNeg } from "../../../../../../../context/NegContext";
import { useDividas } from "../../../../../../../context/DividasContext";
import { ParcelasAcordo } from '../parcelas'
import { ConsultaAcordoResponse, Parcelas } from "../../../../../../../types/consulta-acordo-interface";
import { useBoleto } from "../../../../../../../context/BoletoContext";



export const ContratosAcordo = () => {
  const {
    contratosData,
    dividaData
  } = useContrato()
  const { getAcordos, acordoResponse, setParcelaAcordo, selectedAcordoResponse, setSelectedAcordoResponse } = useNeg()
  const { selectedCredor, devedor } = useDividas()
  const { boleto } = useBoleto()
  const [show, setShow] = useState(false)

  const contratos: Contrato[] = contratosData?.contratos?.length > 0 ? contratosData?.contratos.filter(item => item.permiteacordo) : [] as Contrato[]

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split('/')
    return `${mes}/${dia}/${ano}`
  }

  function acordoContrato(contrato: string) {
    if (contrato === selectedAcordoResponse?.contrato && selectedAcordoResponse?.contrato === acordoResponse?.contrato) {
      setShow(!show)
      return
    }
    if (contrato === selectedAcordoResponse?.contrato && !boleto?.url) {
      setShow(false)
      setParcelaAcordo({} as Parcelas)
      setSelectedAcordoResponse({} as ConsultaAcordoResponse)
      return
    }
    if (contrato === acordoResponse?.contrato && !selectedAcordoResponse?.contrato) {
      setSelectedAcordoResponse(acordoResponse)
      setShow(true)
      return
    }
    if (!boleto?.url) {
      getAcordos({ codcredor: String(selectedCredor?.credor_crm), contrato: contrato, cpf_cnpj: devedor?.cpf_cnpj, url: selectedCredor?.url_ws, app: 'ACIONA_WEB' })
      setShow(true)
      return
    }
  }




  return (
    <>
      {
        contratosData?.contratos?.length > 0 && contratos?.length > 0 && contratos.map(c => (
          <div className="mb-4 rounded-md bg-white ">
            <div className="flex w-full rounded-md border border-gray-400 pr-2">
              <div
                className={`mr-2 w-2 rounded-l-md bg-purple-800 `}
              ></div>
              <div className="w-full py-2">
                <div>
                  <div className="my-2 w-full grid grid-cols-[1fr_0.5fr] gap-2 place-items-center  text-sm">
                    <div className="flex w-full ">
                      <Checkbox
                        color="green"
                        className="mr-2 bg-primary"
                        onChange={() => {
                          acordoContrato(c.numcontrato)
                        }}
                        checked={c.numcontrato === selectedAcordoResponse?.contrato ? true : false}
                      />
                      <strong className="font-medium text-xs text-gray-600">
                        Contrato: {c.numcontrato}
                      </strong>
                    </div>
                    {/* {
                      c.permiteacordo && <div className="flex h-fit items-center p-1 rounded-md gap-1  bg-purple-100 ">
                        <p className="font-semibold text-purple-800">Acordo vigente</p>
                      </div>
                    } */}
                    {/* <p className="font-medium text-xs text-gray-600">
                      Dias em atraso:
                      <strong className="ml-1">
                        {differenceInDays(new Date(), new Date(formatDate(c.vencimento)))}
                      </strong>
                    </p> */}

                    <button
                      className=" flex w-full justify-end"
                      onClick={() => {
                        if (!show) {
                          setShow(true)
                        }
                        acordoContrato(c.numcontrato)
                      }}
                    >
                      {
                        show && selectedAcordoResponse && selectedAcordoResponse?.parcelasacordo?.length > 0 && c.numcontrato === selectedAcordoResponse?.contrato ?
                          <BiMinusCircle size={24} className="fill-primary" /> : <BiPlusCircle size={24} className="fill-primary" />
                      }
                    </button>
                  </div>
                </div>

                <div
                  className={`${(!show && selectedAcordoResponse) && "hidden"} `}
                >

                  {
                    selectedAcordoResponse && selectedAcordoResponse?.parcelasacordo?.length > 0 && selectedAcordoResponse.contrato === c.numcontrato && <ParcelasAcordo parcelas={selectedAcordoResponse?.parcelasacordo} formaPagamento={selectedAcordoResponse?.formapagamento} dataAcordo={selectedAcordoResponse?.datacordo} codigoacordo={selectedAcordoResponse?.codigoacordo} />
                  }
                </div>
              </div>
            </div>
          </div>
        ))
      }
    </>
  )
}